export enum ShopItemType {
  ADOPTABLES = 'adoptables',
  COMMISSIONS = 'commissions',
  PRINTS = 'prints',
  PREMIUM_CONTENT = 'premium_content',
  PREMIUM_FOLDERS = 'premium_folders',
}
